import React from "react";
import "../../styles/Initiatives/SmallTags.css"

const SmallTags = () => {
  return (
    <div className="Initiatives-smallTags">
      {/* <div className="Initiatives-smallTags-content">
        <div className="tag tag1">
          <div className="tag-content"><p>Apply for Amp</p></div>
        </div>
        <div className="tag tag2">
          <div className="tag-content"><p>Get Newsletter</p></div>
        </div>
        <div className="tag tag3">
          <div className="tag-content"><p>Get YearBook</p></div>
        </div>
      </div> */}
    </div>
  );
};

export default SmallTags;
